import { useEffect, useMemo, useState } from "react";
import QRCode from "qrcode";

type Target = "prod" | "test";

const QR_OPTS = { margin: 1, errorCorrectionLevel: "M" as const };

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * QR code for a landing's test or prod URL, with PNG/SVG download.
 * Generated client-side (qrcode) — instant, works offline.
 */
export function QrModal({
  slug,
  prodDomain,
  testDomain,
  prodReady,
  testReady,
  onClose,
}: {
  slug: string;
  prodDomain: string;
  testDomain: string;
  prodReady: boolean;
  testReady: boolean;
  onClose: () => void;
}) {
  const [target, setTarget] = useState<Target>(prodReady ? "prod" : "test");
  const [svg, setSvg] = useState("");

  const url = useMemo(
    () => `https://${target === "prod" ? prodDomain : testDomain}`,
    [target, prodDomain, testDomain],
  );

  useEffect(() => {
    let live = true;
    QRCode.toString(url, { ...QR_OPTS, type: "svg", width: 240 })
      .then((s) => live && setSvg(s))
      .catch(() => live && setSvg(""));
    return () => {
      live = false;
    };
  }, [url]);

  const baseName = `qr-${slug}-${target}`;

  const downloadSvg = async () => {
    const s = await QRCode.toString(url, { ...QR_OPTS, type: "svg", width: 1024 });
    triggerDownload(new Blob([s], { type: "image/svg+xml" }), `${baseName}.svg`);
  };
  const downloadPng = async () => {
    const dataUrl = await QRCode.toDataURL(url, { ...QR_OPTS, width: 1024 });
    const blob = await (await fetch(dataUrl)).blob();
    triggerDownload(blob, `${baseName}.png`);
  };

  return (
    <div className="ov" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="ic">🔳</div>
        <h3>QR-код для печати и раздачи</h3>
        <p>Наведите камеру телефона — откроется выбранная версия лендинга.</p>

        <div className="period" style={{ marginBottom: 16 }}>
          <button
            className={target === "prod" ? "on" : ""}
            onClick={() => setTarget("prod")}
            disabled={!prodReady}
            title={prodReady ? "" : "Сначала опубликуйте сайт"}
          >
            Боевой
          </button>
          <button
            className={target === "test" ? "on" : ""}
            onClick={() => setTarget("test")}
            disabled={!testReady}
            title={testReady ? "" : "Сначала загрузите тест"}
          >
            Тест
          </button>
        </div>

        <div className="qrbox" dangerouslySetInnerHTML={{ __html: svg }} />
        <div className="qrurl">{url}</div>

        <div className="rowend" style={{ marginTop: 18 }}>
          <button className="btn sm" onClick={onClose}>Закрыть</button>
          <button className="btn sm" onClick={downloadSvg}>Скачать SVG</button>
          <button className="btn sm primary" onClick={downloadPng}>Скачать PNG</button>
        </div>
      </div>
    </div>
  );
}
